<template>
  <div>
    <v-row class="mt-0" no-gutters>
      <v-spacer />
      <v-col cols="4">
        <v-select
          v-model="diagnostico"
          :items="diagnosticos"
          label="Diagnóstico:"
          item-text="nome"
          item-value="id"
          return-object
        />
      </v-col>
    </v-row>
    <div v-if="diagnosticos.length > 0">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card-widget title="Informações">
            <div slot="widget-content">
              <v-row no-gutters>
                <v-col cols="6">
                  <span class="font-weight-bold">Diagnóstico: </span>
                  <span class="font-weight-light">{{
                    diagnostico.nome ? diagnostico.nome : ""
                  }}</span>
                </v-col>
                <v-col v-if="usuario !== ''" cols="6">
                  <span v-if="chefia" class="font-weight-bold">Gestor(a):</span>
                  <span v-else class="font-weight-bold">Servidor(a): </span>
                  <span class="font-weight-light">{{ usuario }}</span>
                </v-col>
              </v-row>
            </div>
          </v-card-widget>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card-widget
            :enable-actions="actions"
            :title="titulo ? titulo : 'Relatório'"
          >
            <div slot="widget-content">
              <AppTutorial :tutorial="visibleTutorial" />
              <v-row no-gutters>
                <!-- Slot Body -->
                <slot name="body" />
              </v-row>
            </div>
            <div slot="widget-actions">
              <v-row no-gutters>
                <v-col cols="12">
                  <!-- Slot Actions-->
                  <slot name="actions" />
                </v-col>
              </v-row>
            </div>
          </v-card-widget>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <app-alert
        type="info"
        icon="info"
        message="Usuário não participou de nenhum diagnóstico."
      />
    </div>
  </div>
</template>

<script>
import VCardWidget from '@/components/VWidget';
import AppTutorial from '@/components/core/AppTutorial';
import AppAlert from '@/components/core/AppAlert';
import { mapState } from 'vuex';

export default {
  name: 'AppDesempenho',

  components: {
    VCardWidget,
    AppTutorial,
    AppAlert,
  },

  props: {
    titulo: {
      type: String,
      default: '',
    },
    actions: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    diagnostico: {
      get() {
        return this.$store.state.diagnostico.diagnostico;
      },
      set(diagnostico) {
        this.$store.dispatch('diagnostico/setDiagnostico', diagnostico);
      },
    },
    diagnosticos: {
      get() {
        return this.$store.state.diagnostico.diagnosticos;
      },
      set(diagnosticos) {
        this.$store.dispatch('diagnostico/setDiagnosticos', diagnosticos);
      },
    },
    ...mapState({
      usuario: (state) => state.auth.usuario.nome,
      unidade: (state) => state.auth.unidade,
      comissao: (state) => state.auth.comissao,
      chefia: (state) => state.auth.chefia,
    }),
    visibleTutorial() {
      switch (this.$route.name) {
        case 'DesempenhoComportamental':
          return 'DesempenhoComportamental';
        case 'DesempenhoResponsabilidade':
          return 'DesempenhoResponsabilidade';
        case 'CoeficienteDesempenho':
          return 'CoeficienteDesempenho';
        default:
          return '';
      }
    },
  },
};
</script>
